import styled from '@emotion/styled';
import { GeneralStyles } from '../../components/styles/generalStyles';

export const StyledTextContainer = styled.div`
  padding:  ${({ theme }) => theme.spacings.zetta} 0 ${({ theme }) => theme.spacings.yotta} 0;
  height: 100%;
`;
